import styled from 'styled-components';

export const SignupContainer = styled.div`
  @media only screen and (max-width: 1023px) {
    position: fixed;
    bottom: 0;
  }

  background-color: rgba(29, 28, 28, 1);
  width: 100dvw;
  height: 39px;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: center;
  line-height: 1.7;
  font-size: 16px;
  font-family: 'MaruBuriSemiBold';
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Yellow = styled.span`
  color: #ffef9b;
`;

export const SignupContainer2 = styled.div`
  @media only screen and (max-width: 1023px) {
    position: fixed;
    bottom: 0;
  }
  background-color: #eae9e3;
  width: 100dvw;
  height: 39px;
  position: absolute;
  top: 0;
  left: 0;
  color: #1d1c1c;
  text-align: center;
  line-height: 1.7;
  font-size: 16px;
  font-family: 'MaruBuriSemiBold';
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Gray = styled.span`
  color: #81807f;
`;
